/* WW Sigma Wearable-v2 — section-scoped tab autoplay. */
(function () {
  'use strict';
  if (window.__wwSigmaWearableV2Loaded) return;
  window.__wwSigmaWearableV2Loaded = true;

  function init(root) {
    if (!root || root.__wwsw2Ready || !window.wwTabs) return;
    if (root.getAttribute('data-autoplay-enabled') === 'false') return;
    var tabs = window.wwTabs.tabsIn(root);
    if (tabs.length < 2) return;

    root.__wwsw2Ready = true;
    var interval = parseInt(root.getAttribute('data-autoplay-interval'), 10);
    var delay = (interval >= 1 && interval <= 8 ? interval : 5) * 1000;
    var timer = null;

    function clearTimer() {
      if (timer !== null) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function scheduleNext() {
      clearTimer();
      timer = window.setTimeout(function () {
        if (!root.isConnected) {
          clearTimer();
          return;
        }

        var currentTabs = window.wwTabs.tabsIn(root);
        if (currentTabs.length < 2) return;
        var activeIndex = currentTabs.findIndex(function (tab) {
          return tab.classList.contains('is-active');
        });
        window.wwTabs.activate(root, (activeIndex + 1) % currentTabs.length, 'autoplay');
      }, delay);
    }

    function cleanup() {
      clearTimer();
      root.removeEventListener('ww:tabchange', scheduleNext);
      document.removeEventListener('shopify:section:unload', onUnload);
      root.__wwsw2Cleanup = null;
      root.__wwsw2Ready = false;
    }

    function onUnload(event) {
      if (event.target && event.target.contains && event.target.contains(root)) cleanup();
    }

    root.addEventListener('ww:tabchange', scheduleNext);
    root.__wwsw2Cleanup = cleanup;
    document.addEventListener('shopify:section:unload', onUnload);
    scheduleNext();
  }

  function boot(scope) {
    var context = scope || document;
    if (context.matches && context.matches('.ww-sigma-wearable-v2[data-ww-tabs]')) init(context);
    context.querySelectorAll('.ww-sigma-wearable-v2[data-ww-tabs]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
}());
